function fasthash(value: string) {
  let hash = 0

  for (let i = 0; i < value.length; i++) {
    const character = value.charCodeAt(i)

    hash = (hash << 5) - hash + character
    hash &= hash // Convert to 32bit integer
  }

  return hash
}

function djb2Hash(value: string) {
  return String(fasthash(value) >>> 0)
}

export const Hashing = {
  djb2Hash,
}
